import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { RegistroTutorSolicitudAprobadaDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';



import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class RegistroTutorSolicitudAprobadaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }


  getRegistroTutorSolicitudAprobadaService(): Observable<BodyListResponse<RegistroTutorSolicitudAprobadaDTO>> {
    return this.http.get<BodyListResponse<RegistroTutorSolicitudAprobadaDTO>>(API_URL + '/api/v1/registroTutorSolicitudAprobada/todos');
  }

  guardarRegistroTutorSolicitudAprobadaService(registroTutorSolicitudAprobadaDTO: RegistroTutorSolicitudAprobadaDTO): Observable<BodyResponse<RegistroTutorSolicitudAprobadaDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/registroTutorSolicitudAprobada', registroTutorSolicitudAprobadaDTO);
  }

  getRegistroTutorSolicitudAprobadaPorCodigoService(codigo: string): Observable<BodyResponse<RegistroTutorSolicitudAprobadaDTO>> {
    return this.http.get<BodyResponse<RegistroTutorSolicitudAprobadaDTO>>(API_URL + '/api/v1/registroTutorSolicitudAprobada/' + codigo);
  }
  /********nuevos */

  getRegistroTutorSolicitudAprobadaPorParticipantesSolicitusService(codigo: string): Observable<BodyListResponse<RegistroTutorSolicitudAprobadaDTO>> {
    return this.http.get<BodyListResponse<RegistroTutorSolicitudAprobadaDTO>>(API_URL + '/api/v1/registroTutorSolicitudAprobada/solicitudParticipantes/' + codigo);
  }
}
